// extracted by mini-css-extract-plugin
export default {"dragLabelContainer":"styles_dragLabelContainer__y7V71","dragLabel":"styles_dragLabel__YaaoL","dragging":"styles_dragging__dg-at"};